import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-magic-link',
  standalone: true,
  imports: [],
  template: `
    <div
      style="min-height:100vh;display:flex;align-items:center;justify-content:center;
                background:#f4f6f8;font-family:Arial,sans-serif;"
    >
      <div style="text-align:center;padding:40px;">
        @if (!error && !verified) {
          <div
            style="width:48px;height:48px;border:4px solid #e5e7eb;
                      border-top-color:#2563eb;border-radius:50%;
                      animation:spin 0.8s linear infinite;margin:0 auto 20px;"
          ></div>
          <p style="color:#374151;font-size:16px;margin:0;">Verifying your invitation…</p>
        }

        @if (verified) {
          <p style="font-size:40px;margin:0;">✅</p>
          <p style="color:#16a34a;font-size:16px;margin:16px 0 0;font-weight:600;">
            Invitation verified, taking you to booking…
          </p>
        }

        @if (error) {
          <p style="font-size:48px;margin:0;">⚠️</p>
          <h2 style="color:#111827;margin:16px 0 8px;">Link Invalid or Expired</h2>
          <p style="color:#6b7280;font-size:15px;max-width:360px;margin:0 auto;">{{ error }}</p>
          <p style="color:#9ca3af;font-size:14px;margin-top:16px;">
            Please contact the recruiter to resend your invitation.
          </p>
        }
      </div>
    </div>
    <style>
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    </style>
  `,
})
export class MagicLinkComponent implements OnInit {
  error = '';
  verified = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.error = 'No invitation token found in the link.';
      return;
    }

    this.http
      .post<{ token: string }>(`${environment.apiUrl}/api/v1/auth/magic-link/verify`, { token })
      .subscribe({
        next: (res) => {
          sessionStorage.setItem('candidate_token', res.token);
          // Without this, a successful verification silently jumped to
          // booking with no confirmation the link actually worked.
          this.verified = true;
          setTimeout(() => {
            this.router.navigate(['/app/candidate/book-interview'], { replaceUrl: true });
          }, 900);
        },
        error: (err) => {
          this.error = err.error?.error ?? 'Verification failed. Please try again.';
        },
      });
  }
}
